class MenuDrawer extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.addDirectEvent("menulink:click", document, (event) => {
      this.show(event.detail.target);
    });

    this.addDirectEvent("close", this.elements.dialog, () => {
      this.trigger?.setAttribute("aria-expanded", "false");
      this.trigger?.focus();
    });

    this.addEvent("click", this.elements.dialog, (event) => {
      if (event.target !== this.elements.dialog) return;

      const bounds = this.elements.dialog.getBoundingClientRect();

      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) {
        this.hide();
      }
    });

    this.addEvent("keydown", this.elements.dialog, (event) => {
      if (event.key !== "Tab") return;

      const controls = Array.from(this.elements.dialog.querySelectorAll("a[href], button:not([disabled])"));
      const first = controls[0];
      const last = controls.at(-1);

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  show(trigger) {
    this.trigger = trigger;
    this.elements.dialog.showModal();
    this.trigger.setAttribute("aria-expanded", "true");
  }

  hide() {
    this.elements.dialog.close();
  }
}

customElements.define("menu-drawer", MenuDrawer);
